import React from 'react';

import type { AddressFromToFilter } from 'types/api/address';

import useIsInitialLoading from 'lib/hooks/useIsInitialLoading';
import { useI18n } from 'lib/i18n/context';
import PopoverFilterRadio from 'ui/shared/filters/PopoverFilterRadio';

import { ADDRESS_FILTER_OPTION_KEYS } from './i18n';

interface Props {
  hasActiveFilter: boolean;
  defaultFilter: AddressFromToFilter;
  onFilterChange: (nextValue: string | Array<string>) => void;
  isLoading?: boolean;
}

const AddressTxsFilter = ({ onFilterChange, defaultFilter, hasActiveFilter, isLoading }: Props) => {
  const isInitialLoading = useIsInitialLoading(isLoading);
  const { t } = useI18n();
  const options = React.useMemo(() => ADDRESS_FILTER_OPTION_KEYS.map((option) => ({
    ...option,
    label: t(option.labelKey),
  })), [ t ]);

  return (
    <PopoverFilterRadio
      name="txs_filter"
      options={ options }
      onChange={ onFilterChange }
      hasActiveFilter={ hasActiveFilter }
      isLoading={ isInitialLoading }
      defaultValue={ defaultFilter || options[0].value }
    />
  );
};

export default React.memo(AddressTxsFilter);
